import _slicedToArray from "/Users/alvaramat/game-dices/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export default function classes(classNames) {
  return Object.entries(classNames).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        cls = _ref2[0],
        display = _ref2[1];

    return cls && display;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        cls = _ref4[0];

    return cls;
  }).join(' ');
}